/*
 * @Author: luting
 * @Date: 2022-04-15 16:33:21
 * @lastEditors: luting
 * @LastEditTime: 2023-07-11 13:47:28
 */
import { CHANGEENVSTATUS } from 'root/store/constant';

const changeEnvStatus = (payload: {
  singleNodeId?: string;
  runtimeEnvId?: string;
  acitveKey?: string;
  isSuposInstalled?: boolean;
  hasHost?: boolean;
  hasOperatingEnv?: boolean;
  cluster?: boolean;
  suposInstalled?: string;
  singleServerNodeId?: string;
  refersh?: boolean;
  opsIp?: string;
  opsPort?: string;
  colonySpinning?: boolean;
  initPassword?: boolean;
}) => ({
  type: CHANGEENVSTATUS,
  payload,
});

export const envManage = {
  changeEnvStatus,
};
